'use client';
import { makeIcon } from '@vkontakte/icons-sprite';
export var Icon28LogoWink = makeIcon('Icon28LogoWink', 'logo_wink_28', '0 0 28 28', '<symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" id="logo_wink_28"><path fill="currentColor" d="M11.998 4 6.6 9.398l4.569 4.562L6.6 18.523l5.398 5.397 9.96-9.96z" /></symbol>', 28, 28, false, undefined);
